import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers/user-preferences';

export const selectUserPreferenceState = createFeatureSelector<State>('userPreferences');

export function getUserPreferences() {
    return createSelector([selectUserPreferenceState], (userPreferences: State) => userPreferences.effectiveValues);
  }